import { faArrowDown, faArrowUp } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Flex } from '@mantine/core';
import classNames from 'classnames';
import type { JSX } from 'react';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useRouteMatch } from 'react-router-dom';

import { Text } from '@feathr/components';
import GrowthCreditIcon from '@feathr/extender/components/GrowthCreditIcon/GrowthCreditIcon';
import { useLocalUrl } from '@feathr/extender/state';

import * as styles from './CreditsCard.css';

// TODO: Replace with API call once backend endpoint is available
const MOCK_CREDITS = 3100;

// TODO: Credit change indicator is TBD - need to determine how/when to show +/- changes
const MOCK_CREDIT_CHANGE: number | null = null;

// TODO: Figma specifies Fira Mono font for credits value - need to add --font-mono CSS variable

function CreditsCard(): JSX.Element {
  const { t } = useTranslation();
  const localUrl = useLocalUrl();
  const match = useRouteMatch<{ accountId: string; primary: string; secondary?: string }>({
    path: '/:accountId/:primary/:secondary?',
  });

  const isActive =
    match?.params.primary === 'fundraise' && match?.params.secondary === 'growth-credits';
  const credits = MOCK_CREDITS;
  const creditChange = MOCK_CREDIT_CHANGE;

  const formattedCredits = credits.toLocaleString();

  // TODO: Change indicator display logic is TBD
  // Will show up/down arrows with +/- values when creditChange is non-null and non-zero
  const changeIndicator =
    creditChange !== null && creditChange !== 0 ? (
      <span
        className={classNames({
          [styles.changePositive]: creditChange > 0,
          [styles.changeNegative]: creditChange < 0,
        })}
      >
        <FontAwesomeIcon icon={creditChange > 0 ? faArrowUp : faArrowDown} />
        {creditChange > 0 ? '+' : ''}
        {creditChange.toLocaleString()}
      </span>
    ) : null;

  return (
    <Link
      className={classNames(styles.link, { [styles.active]: isActive })}
      to={localUrl('/fundraise/growth-credits')}
    >
      <div className={classNames(styles.root, { [styles.active]: isActive })}>
        <Flex align={'flex-start'} gap={'sm'}>
          <GrowthCreditIcon />
          <Flex direction={'column'}>
            <Flex align={'center'} gap={'xs'}>
              <Text.DefaultSemibold>{formattedCredits}</Text.DefaultSemibold>
              {changeIndicator}
            </Flex>
            <Text.SmallRegular className={styles.label}>{t('credits')}</Text.SmallRegular>
          </Flex>
        </Flex>
      </div>
    </Link>
  );
}

export default CreditsCard;
